export const HELP_TOOLTIP_DELAY_MS = 500;
